(ns capra.stub
  "Client-side capability stub.
   A CapraStub represents a server-side capability the client holds."
  (:require
   [capra.protocol :as proto]))

(defrecord CapraStub [cap-id cap-type cap-methods meta])

(defn stub? [x]
  (instance? CapraStub x))

(defn stub->wire
  "Convert a stub to its wire form (#rpc/cap)."
  [stub]
  (proto/->Cap (:cap-id stub)))

(defn cap->stub
  "Build a stub from a capability advertisement."
  [{:keys [id type methods meta]}]
  (->CapraStub id type methods meta))

(defn caps->stubs
  "Convert a vector of cap advertisements to a map of cap-id → CapraStub."
  [caps]
  (into {}
        (map (fn [adv] [(:id adv) (cap->stub adv)]))
        caps))
